module.exports = __webpack_public_path__ + "img/mian.877e82ce.jpg";